exports.computeSelectionWidth = boundingBox => boundingBox.get('width');
